function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import get from 'lodash/get';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import find from 'lodash/find';
import FormGroup from 'components/Form/FormGroup';
import messages from 'modules/App/messages';
import styles from './MobileCountryCodeFormPartial.pcss';
import CountryFlagImage from './CountryFlagImage';
import FullScreenCountrySelector from './FullScreenCountrySelector';
const MobileCountryCodeFormPartial = ({ id, formValues, optionsFrom, isDisabled, onChange })=>{
    useStyles(styles);
    const [isSelectorOpen, setIsSelectorOpen] = useState(false);
    const currentValue = get(formValues, `values.${id}`);
    const label = get(find(optionsFrom, {
        value: currentValue
    }), 'label');
    const buttonMessage = currentValue ? messages.buttons.change : messages.buttons.chooseCountry;
    const onClick = ()=>{
        setIsSelectorOpen(true);
    };
    const onCloseSelector = ()=>{
        setIsSelectorOpen(false);
    };
    return /*#__PURE__*/ _jsx(FormGroup, {
        id: id,
        labelMessage: null,
        className: styles.countrySelectionFormGroup,
        formValues: formValues,
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.countrySelectionControl, {
                        [styles['countrySelectionControl--disabled']]: isDisabled
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(CountryFlagImage, {
                            className: styles.countrySelectionControl__flag,
                            countryCode: currentValue
                        }),
                        label && /*#__PURE__*/ _jsx("p", {
                            className: "mr-3",
                            children: label
                        }),
                        !isDisabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                        /*#__PURE__*/ _jsx("a", {
                            className: styles.countrySelectionControl__actionButton,
                            onClick: onClick,
                            "data-testid": "choose-country",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, buttonMessage))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(FullScreenCountrySelector, {
                    id: id,
                    formValues: formValues,
                    optionsFrom: optionsFrom,
                    isSelectorOpen: isSelectorOpen,
                    onChange: onChange,
                    onCloseSelector: onCloseSelector
                })
            ]
        })
    });
};
export default MobileCountryCodeFormPartial;
